<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
				
				<Row>
					<Col span="">
						<FormItem label="公司名称" prop="companyName" class="">
							<Input v-model="formValidate.companyName" placeholder="请输入公司名称" ></Input>
						</FormItem>
					</Col>
					<Col span="">
						<FormItem label="区划信息" prop="companyName" class="">
							<Input v-model="formValidate.region.mergerName" disabled="disabled" ></Input>
						</FormItem>
					</Col>
					<Col span="">
						<FormItem label="公司地址" prop="address" class="">
							<Input v-model="formValidate.address" placeholder="请输入公司地址" ></Input>
						</FormItem>
					</Col>
					<Col span="">
						<FormItem label="联系方式1" prop="phone1" class="">
							<Input v-model="formValidate.phone1" placeholder="请输入联系方式"></Input>
						</FormItem>
					</Col>
					<Col span="">
						<FormItem label="联系方式2" prop="phone2" class="">
							<Input v-model="formValidate.phone2" placeholder="请输入联系方式"></Input>
						</FormItem>
					</Col>
					<Col span="">
						<FormItem label="联系方式3" prop="phone3" class="">
							<Input v-model="formValidate.phone3" placeholder="请输入联系方式(当联系方式超过三个时，用;进行分割)"></Input>
						</FormItem>
					</Col>
					<Col span="">
						<FormItem label="邮箱" prop="mailbox" class="">
							<Input v-model="formValidate.mailbox" placeholder="请输入名称"></Input>
						</FormItem>
					</Col>
					<Col>
						<FormItem label="状态" prop="state" class="sj">
							<Select v-model="formValidate.state" placeholder="请选择状态">
								<Option value="true">启用</Option>
								<Option value="false">禁用</Option>
							</Select>
						</FormItem>
					</Col>
					
					<Col span="8">
						<FormItem label="登陆用户名" class="" prop='username'>
							<Input placeholder="请输入登录用户名" v-model="formValidate.username" disabled="disabled"></Input>
						</FormItem>
					</Col>
					<Col span="8">
						<FormItem label="登陆密码" prop="password" class="">
							<Input v-model="formValidate.password" placeholder="请输入登录密码"   disabled="disabled"></Input>
						</FormItem>
					</Col>
					<Col span="8">
						<FormItem label="登陆账号状态" prop="empState" class="sj">
							<Select v-model="formValidate.empState" placeholder="请选择状态">
								<Option value="true">启用</Option>
								<Option value="false">禁用</Option>
							</Select>
						</FormItem>
					</Col>
					<Col span="8">
						<FormItem label="银行卡所属人" class="" prop="bankName">
							<Input placeholder="请输入姓名" v-model="formValidate.bankName"></Input>
						</FormItem>
					</Col>
					<Col span="8">
						<FormItem label="银行名称" prop="cardName" class="">
							<Input v-model="formValidate.cardName" placeholder="请输入银行名称"></Input>
						</FormItem>
					</Col>
					<Col span="8">
						<FormItem label="卡号" prop="cardNumber" class="">
							<Input v-model="formValidate.cardNumber" placeholder="请输入卡号"></Input>
						</FormItem>
					</Col>
				</Row>
				
				
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				imgBool:true,
				formValidate: {
					id:'',
					companyName: '',
					address: '',
					phone1: '',
					phone2: '',
					phone3:'',
					mailbox:'',
					state:'true',
					username:'',
					password:'',
					regionId:'',
					cardName:'',
					bankName:'',
					cardNumber:'',
					empState:'true'
					
				},
				ruleValidate: {
					empState: [{
						required: true,
						message: '管理员登陆账号状态不能为空！！！',
						trigger: 'blur'
					}],
					cardName: [{
						required: true,
						message: '银行名称不能为空！！！',
						trigger: 'blur'
					}],
					bankName: [{
						required: true,
						message: '所属人不能为空！！！',
						trigger: 'blur'
					}],
					cardNumber: [{
						required: true,
						message: '银行卡号不能为空！！！',
						trigger: 'blur'
					}],
					phone1: [{
						required: true,
						message: '至少要有一个联系方式！！！',
						trigger: 'blur'
					}],
					companyName: [{
						required: true,
						message: '名称不能为空！！！',
						trigger: 'blur'
					}],
					mailbox: [
                        { required: true, message: '邮箱不能为空', trigger: 'blur' },
                        { type: 'email', message: '邮箱格式错误', trigger: 'blur' }
                    ],
					operType: [
                        { required: true, message: '运营商类型不能为空', trigger: 'blur' }
                    ],
					state: [
                        { required: true, message: '状态不能为空', trigger: 'blur' }
                    ]
				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				let _this=this
				this.$refs[name].validate((valid) => {
					if (valid) {
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/plat/alliance/update/jm',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功!');
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
						
					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			imgFile(files){
				this.formValidate.img=files
				if(this.formValidate.img.length>0){
					this.imgBool=false
				}else{
					this.imgBool=true
				}
			},
			get(id){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'POST',
				    url: http.url + '/plat/alliance/get1',
				    data: {id:id},
					_this: _this,
					success: function(data) {
						_this.formValidate = data.alliance
						if(data.alliance.state==true){
							_this.formValidate.state='true'
						}else{
							_this.formValidate.state='false'
						}
						if(_this.formValidate.empState){
							_this.formValidate.empState='true'
						}else{
							_this.formValidate.empState='false'
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			queryRegion(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/region/queryByJmEmpId',
				    data: {},
					_this: _this,
					success: function(data) {
						_this.list1=data.vo.oneRegions
						_this.list2=data.vo.twoRegions
						_this.list3=data.vo.threeRegions
						_this.region.one=_this.list1[0].id
						_this.region.two=_this.list2[0].id
						_this.region.three=_this.list3[0].id
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
		components:{
			
		},
		created() {
			let id=this.$route.query.id;
			if(id==undefined || id==null || id==""){
				this.$Message.error('系统错误请刷新!');
			}else{
				this.formValidate.id=id
				this.get(id)
				//this.queryRegion()
			}
			
			
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.content {
		margin-left: 10%;
		width: 900px;

	}

	.ivu-form-item {
		margin-bottom: 5px;
	}
	.ivu-col{
		margin-bottom: 20px;
	}

</style>



// WEBPACK FOOTER //
// src/components/jm/platform/alliance/update.vue